import { render, staticRenderFns } from "./DirectMailSpend.vue?vue&type=template&id=676fccbc&"
import script from "./DirectMailSpend.vue?vue&type=script&lang=js&"
export * from "./DirectMailSpend.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports